import React from "react"
import Layout from "../components/layout"
import Pager from '../components/pager';
import { Link, graphql } from 'gatsby'
import SEO from "../components/seo"
import styled from "@emotion/styled"

/* Blog Title Looks */
const BlogHeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`

const BlogHeader = styled.h1`
  font-size: 3rem;
  margin: 0;

  @media (max-width: 425px) {
    margin-top: 5rem;
  }
`

const ColorPop = styled.span`
  color: #f80c16;
`

const BlogTagline = styled.p`
  margin: 0;
`

/* Blog Archive Looks */
const BlogTitleContainer = styled.div`
  display: relative;
  cursor: pointer;
  width: 55%;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 425px) {
    width: 100%;
  }
`
const BlogLink = styled(props => <Link {...props} />)`
  text-decoration: none;
  color: #000000FF;
  cursor: pointer; 
`

const BlogArchiveTitle = styled.h3`
  padding: 1rem;
  font-size: 1rem;
  color: #000000FF;
  border: 2px solid #000000FF;
  border-radius: 10rem;
  letter-spacing: .15rem;
  line-height: 1.5rem;
  text-transform: uppercase;
  font-weight: 600;
  -webkit-transition: background-color 0.3s ease;
  -o-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: #f80c16;
    color: #ffffff
  }

  
  @media (max-width: 320px) {
    line-height: 1.25rem; 
  }
`

const BlogArchiveDate = styled.p`
  font-weight: 400;
  margin: 0;
  margin-top: 0.5rem;
`
 
export const pageQuery = graphql`
  query blogPageQuery($skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
          }
        }
      }
    }
  }
`

const BlogArchive = ({ data, pageContext, location }) => {
    const posts = data.allMarkdownRemark.edges;

    return (
      <Layout location={location}>
        <SEO title="Blog" />
        <BlogHeaderContainer>
          <BlogHeader>Things I Wrote<ColorPop>.</ColorPop></BlogHeader>
          <BlogTagline>(All the good, the bad, and the ugly...)</BlogTagline>
        </BlogHeaderContainer>
        {posts.map(({ node }) => {
            const title = node.frontmatter.title || node.fields.slug
            return (
              <BlogTitleContainer key={node.fields.slug}>
                <BlogLink to={node.fields.slug}>
                <BlogArchiveTitle>
                    {title}
                    <BlogArchiveDate>
                        {node.frontmatter.date}
                    </BlogArchiveDate>
                </BlogArchiveTitle>
                </BlogLink>
              </BlogTitleContainer>
            )
        })}

        <Pager pageContext={pageContext} />
      </Layout>
    )
};

export default BlogArchive;